// @flow

import { RECEIVE_FACETS } from '../constants';
import type { ReceiveFacetsAction } from '../actions';
import type { State } from '../types';

type FacetState = $PropertyType<State, 'facets'>;

const initialState: FacetState = {};

const facets = (
  state: FacetState = initialState,
  action: ReceiveFacetsAction,
): FacetState => {
  switch (action.type) {
    case RECEIVE_FACETS:
      return action.payload;
    default:
      return state;
  }
};

export default facets;
